// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__VNn5c","inner":"Wrapper_inner__KsvX2"};